import React from 'react';
import { Box, Typography, Container, Button, Paper, Grid, Link as MuiLink } from '@mui/material';
import { Email, LocationOn } from '@mui/icons-material';
import { Link } from 'react-router-dom';

export default function Contact() {
  return (
    <Box sx={{ py: { xs: 4, md: 8 }, backgroundColor: '#f0f4f8', minHeight: '100vh' }}>
      <Container maxWidth="md">
        <Typography
          variant="h2"
          align="center"
          gutterBottom
          sx={{ fontWeight: 700, mb: { xs: 4, md: 6 } }}
        >
          Get in Touch
        </Typography>

        <Grid container spacing={4}>
          {/* Email Cards */}
          {[
            { label: 'General Queries', email: 'info@mmai.live' },
            { label: 'Customer Support', email: 'support@mmai.live' },
            { label: 'Billing & Refunds', email: 'billing@mmai.live' },
          ].map((item, idx) => (
            <Grid item xs={12} sm={6} md={4} key={idx}>
              <Paper
                elevation={2}
                sx={{
                  p: 3,
                  textAlign: 'center',
                  borderRadius: 3,
                  transition: 'transform 0.2s',
                  '&:hover': { transform: 'scale(1.03)', boxShadow: 6 },
                }}
              >
                <Email fontSize="large" color="primary" sx={{ mb: 1 }} />
                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600 }}>
                  {item.label}
                </Typography>
                <MuiLink href={`mailto:${item.email}`} underline="none" sx={{ wordBreak: 'break-all' }}>
                  <Typography variant="body2" color="text.primary">
                    {item.email}
                  </Typography>
                </MuiLink>
              </Paper>
            </Grid>
          ))}

          {/* Address Section */}
          <Grid item xs={12}>
            <Paper elevation={2} sx={{ p: { xs: 3, md: 4 }, borderRadius: 3 }}>
              <Box display="flex" alignItems="flex-start">
                <LocationOn color="action" sx={{ mr: 2, mt: 0.5 }} />
                <Box>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                    Business Address
                  </Typography>
                  <Typography variant="body2" color="text.secondary" component="address">
                    MindMapper AI<br />
                    2482 Yonge Street #1414<br />
                    Toronto, ON M4P 2H5<br />
                    Canada
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>

          {/* Footer Links */}
          <Grid item xs={12}>
            <Box display="flex" justifyContent="center" flexWrap="wrap" gap={2} mt={2}>
              <Button
                variant="outlined"
                component={Link}
                to="/privacy"
                sx={{ minWidth: 150, borderRadius: 2 }}
              >
                Privacy Policy
              </Button>
              <Button
                variant="outlined"
                component={Link}
                to="/terms"
                sx={{ minWidth: 150, borderRadius: 2 }}
              >
                Terms & Conditions
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
